import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function SiteFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-accent-950">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">久久久精品</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">{t('footerDesc')}</p>
            <p className="mt-4 inline-flex items-center gap-2 rounded-full bg-primary-900/60 px-3 py-1.5 text-xs text-background-200/80">
              <i className="ri-information-line"></i>
              {t('footerDisclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-400">{t('footerNav')}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navHome')}</Link></li>
              <li><Link to="/search" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navSearch')}</Link></li>
              <li><Link to="/favorites" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navFavorites')}</Link></li>
              <li><Link to="/about" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navAbout')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-400">{t('footerCategory')}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/category/movie" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navMovie')}</Link></li>
              <li><Link to="/category/tv" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navTv')}</Link></li>
              <li><Link to="/category/variety" className="text-background-200/80 transition hover:text-accent-300 cursor-pointer">{t('navVariety')}</Link></li>
            </ul>
            <div className="mt-5 flex gap-2">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900/60 text-background-200/80 transition hover:bg-accent-500 hover:text-accent-950 cursor-pointer"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-2 border-t border-primary-900 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {t('footerCopyright')}</p>
          <p>{t('legalTitle')}</p>
        </div>
      </div>
    </footer>
  );
}